'use client';
import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgDotsHorizontal = function SvgDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.5 11.997c0-.275-.225-.5-.5-.497-.275 0-.5.225-.5.5s.225.5.5.5.5-.225.5-.503ZM12.5 11.997c0-.275-.225-.5-.5-.497-.275 0-.5.225-.5.5s.225.5.5.5.5-.225.5-.503ZM18.5 11.997c0-.275-.225-.5-.5-.497-.275 0-.5.225-.5.5s.225.5.5.5.5-.225.5-.503Z",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgDotsHorizontal as default };
//# sourceMappingURL=dots-horizontal.svg.js.map
